import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeSkeletonKey extends TraitRegistryItem {
    customFilter;
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
